/*
 * 函数 flatArrMenu 将右键数据结构扁平化 层级为1 形如：[{childmenu:'ccc',parentmenu:'ppp',childName:'nnn'}]
 * 函数 initLoopSetMenu 将扁平化 数组  处理为层级结构(无限)[{childmenu:'ccc',parentmenu:'ppp',childName:'nnn',children:[{}...]}]
 */

export function flatArrMenu(list) {
    let cloneArr = [];
    list.map(father => {
        father.boxNewList?father.boxNewList.map(child => {
            child.parentmenu = father.menuName;
            cloneArr.push(child)
        }):false
    })
    return cloneArr
}

export function initTreeMenu(flatData, id, parentId, children) {
    return flatData.filter(father => {
        let boxNewList = flatData.filter(child => father[id] == child[parentId]);
        boxNewList.length > 0 ? father[children] = boxNewList : ''
        return father[parentId] == 'topMenu'
    })
}



// WEBPACK FOOTER //
// ./src/store/helper.js